"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("./styles");
const tracking_utils_1 = require("../../lib/tracking.utils");
const messages_1 = __importDefault(require("../../lib/messages"));
const ExpandableCardContainer = ({ id, children, track }) => {
    // height of the content that the expandable container is wrapping, which
    // can change (e.g. filtering provider insurances accepted)
    const [contentHeight, setContentHeight] = (0, react_1.useState)(0);
    // target height of the expandable container
    const [containerHeight, setContainerHeight] = (0, react_1.useState)(0);
    // boolean that tracks if the content exceeds 600px
    const [isExpandable, setIsExpandable] = (0, react_1.useState)(false);
    // the HTML elements that need to be removed from the tab index when collapsed
    const [focusableElementsToHide, setFocusableElementsToHide] = (0, react_1.useState)([]);
    const content = (0, react_1.useRef)(null);
    const container = (0, react_1.useRef)(null);
    const button = (0, react_1.useRef)(null);
    // listen for resize events
    (0, react_1.useEffect)(() => {
        if (!content.current)
            return;
        if (typeof window !== undefined && window.ResizeObserver) {
            const resizeObserver = new ResizeObserver(() => {
                var _a;
                setContentHeight(((_a = content.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
            });
            resizeObserver.observe(content.current);
            return () => resizeObserver.disconnect();
        }
        return;
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (contentHeight > 600) {
            setContainerHeight(600);
            setIsExpandable(true);
            // get all the focusable elements in the content container
            const focusableElements = (_a = content.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a[href], button:enabled');
            // build an array of all the elements that need to be hidden when collapsed, based
            // on offsetTop of the elements and the container. only going to hide the ones that
            // are below the fold of the collapsed container (not visible, for accessibility)
            const elementsToHide = [];
            setTimeout(() => {
                focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements.forEach((element) => {
                    const tabIndex = parseInt(element.getAttribute('tabindex') || '0');
                    if (container.current &&
                        element.getBoundingClientRect().top >
                            container.current.getBoundingClientRect().bottom &&
                        tabIndex >= 0) {
                        // if the top of the element is below the fold of the collapsed container,
                        // add it to the array and remove it from the tab index
                        elementsToHide.push(element);
                        element.tabIndex = -1;
                    }
                });
            }, 10);
            setFocusableElementsToHide(elementsToHide);
        }
        else {
            setIsExpandable(false);
            setContainerHeight(0);
        }
    }, [contentHeight]);
    const handleButtonClick = () => {
        if (containerHeight === contentHeight) {
            // show less click (collapse)
            (0, tracking_utils_1.trackShowMoreClick)(track, 'hide', id);
            setContainerHeight(600);
            setIsExpandable(true);
            // if we're collapsing, hide the focusable elements, collapse the container and
            // scroll the button (which is focused) into view
            focusableElementsToHide.forEach((element) => {
                element.tabIndex = -1;
            });
            setTimeout(() => {
                var _a, _b;
                const buttonIsOffscreen = (((_a = button.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y) || 0) < 0;
                if (buttonIsOffscreen) {
                    (_b = button.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
                }
            }, 10);
        }
        else {
            // show more click (EXPAND!)
            (0, tracking_utils_1.trackShowMoreClick)(track, 'show', id);
            setContainerHeight(contentHeight);
            setIsExpandable(false);
            // if we're expanding, add the hidden elements back into the tab index
            setTimeout(() => {
                focusableElementsToHide.forEach((element) => {
                    if (container.current) {
                        if (container.current.getBoundingClientRect().bottom >
                            element.getBoundingClientRect().top) {
                            element.tabIndex = 0;
                        }
                    }
                    else {
                        element.tabIndex = 0;
                    }
                });
            }, 10);
        }
    };
    return (react_1.default.createElement(styles_1.ExpandableCard, { "data-testid": "ExpandableCard" },
        react_1.default.createElement(styles_1.ExpandableContainer, { "data-testid": "ExpandableContainer", id: id, containerHeight: containerHeight, isExpandable: isExpandable, ref: container },
            react_1.default.createElement("div", { ref: content }, children)),
        contentHeight > 600 && (react_1.default.createElement(button_1.default, { className: "show-more-button", mode: "secondary", onClick: handleButtonClick, ref: button, "aria-expanded": !isExpandable, "aria-controls": id }, isExpandable ? (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.reviewsShowMore))) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.reviewsShowLess)))))));
};
exports.default = ExpandableCardContainer;
//# sourceMappingURL=expandable-card-container.js.map